export const PORTAL_ID = '4488620';
